// USER LIST
export const PAYMENT_METHOD_MANAGER_LIST = "PAYMENT_METHOD_MANAGER_LIST";
export const PAYMENT_METHOD_MANAGER_LIST_SUCCESS = "PAYMENT_METHOD_MANAGER_LIST_SUCCESS";
export const PAYMENT_METHOD_MANAGER_LIST_FAIL = "PAYMENT_METHOD_MANAGER_LIST_FAIL";
export const PAYMENT_METHOD_MANAGER_LIST_RESET = "PAYMENT_METHOD_MANAGER_LIST_RESET";
export const PAYMENT_METHOD_MANAGER_LIST_COLUMN = "PAYMENT_METHOD_MANAGER_LIST_COLUMN";

// USER ROLE LIST
export const PAYMENT_METHOD_MANAGER_ROLE_LIST = "PAYMENT_METHOD_MANAGER_ROLE_LIST";
export const PAYMENT_METHOD_MANAGER_ROLE_LIST_SUCCESS = "PAYMENT_METHOD_MANAGER_ROLE_LIST_SUCCESS";
export const PAYMENT_METHOD_MANAGER_ROLE_LIST_FAIL = "PAYMENT_METHOD_MANAGER_ROLE_LIST_FAIL";
export const PAYMENT_METHOD_MANAGER_ROLE_LIST_RESET = "PAYMENT_METHOD_MANAGER_ROLE_LIST_RESET";
export const PAYMENT_METHOD_MANAGER_ROLE_LIST_COLUMN = "PAYMENT_METHOD_MANAGER_ROLE_LIST_COLUMN";

// USER CREATE
export const PAYMENT_METHOD_MANAGER_CREATE = "PAYMENT_METHOD_MANAGER_CREATE";
export const PAYMENT_METHOD_MANAGER_CREATE_SUCCESS = "PAYMENT_METHOD_MANAGER_CREATE_SUCCESS";
export const PAYMENT_METHOD_MANAGER_CREATE_FAIL = "PAYMENT_METHOD_MANAGER_CREATE_FAIL";
export const PAYMENT_METHOD_MANAGER_CREATE_RESET = "PAYMENT_METHOD_MANAGER_CREATE_RESET";

// USER DETAIL
export const PAYMENT_METHOD_MANAGER_DETAIL = "PAYMENT_METHOD_MANAGER_DETAIL";
export const PAYMENT_METHOD_MANAGER_DETAIL_SUCCESS = "PAYMENT_METHOD_MANAGER_DETAIL_SUCCESS";
export const PAYMENT_METHOD_MANAGER_DETAIL_FAIL = "PAYMENT_METHOD_MANAGER_DETAIL_FAIL";
export const PAYMENT_METHOD_MANAGER_DETAIL_RESET = "PAYMENT_METHOD_MANAGER_DETAIL_RESET";

// USER UPDATE
export const PAYMENT_METHOD_MANAGER_UPDATE = "PAYMENT_METHOD_MANAGER_UPDATE";
export const PAYMENT_METHOD_MANAGER_UPDATE_SUCCESS = "PAYMENT_METHOD_MANAGER_UPDATE_SUCCESS";
export const PAYMENT_METHOD_MANAGER_UPDATE_FAIL = "PAYMENT_METHOD_MANAGER_UPDATE_FAIL";
export const PAYMENT_METHOD_MANAGER_UPDATE_RESET = "PAYMENT_METHOD_MANAGER_UPDATE_RESET";

// USER DELETE
export const PAYMENT_METHOD_MANAGER_DELETE = "PAYMENT_METHOD_MANAGER_DELETE";
export const PAYMENT_METHOD_MANAGER_DELETE_SUCCESS = "PAYMENT_METHOD_MANAGER_DELETE_SUCCESS";
export const PAYMENT_METHOD_MANAGER_DELETE_FAIL = "PAYMENT_METHOD_MANAGER_DELETE_FAIL";
export const PAYMENT_METHOD_MANAGER_DELETE_RESET = "PAYMENT_METHOD_MANAGER_DELETE_RESET";

// USER ACTIVE
export const PAYMENT_METHOD_MANAGER_ACTIVE = "PAYMENT_METHOD_MANAGER_ACTIVE";
export const PAYMENT_METHOD_MANAGER_ACTIVE_SUCCESS = "PAYMENT_METHOD_MANAGER_ACTIVE_SUCCESS";
export const PAYMENT_METHOD_MANAGER_ACTIVE_FAIL = "PAYMENT_METHOD_MANAGER_ACTIVE_FAIL";
export const PAYMENT_METHOD_MANAGER_ACTIVE_RESET = "PAYMENT_METHOD_MANAGER_ACTIVE_RESET";
